import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('../../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/IN_7011_720p_HD_Pan_Tilt_IP_Kamera_fuer_den_Außeneinsatz_iPad_App.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Die INSTAR IN - 7011 ist eine 720p- HD Pan&Tilt-IP-Kamera der Firma INSTAR. Sie bietet noch zahlreiche weitere Features:</p>
            <ul>
              <li>- MegaPixel 720p HD Auflösung</li>
              <li>- hochwertiger WDR Sensor für die Wiedergabe schwieriger Lichtverhältnisse</li>
              <li>- H264 Videokomprimierung</li>
              <li>- selektierbare Bewegungserkennung</li>
              <li>- ONVIF Support</li>
              <li>- Aufnahme direkt auf eine integrierte MicroSD Karte (2GB im Lieferumfang enthalten)</li>
            </ul>
            <p>Auf <OutboundLink href="https://www.youtube.com/watch?v=9JCRp329I0I" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)